import React from "react";

// Lazy-loaded page components so we can render them inside an overlay on "/".
const lazyFromRoute = (loader: () => Promise<{ Route: { options: { component?: React.ComponentType } } }>) =>
  React.lazy(async () => {
    const m = await loader();
    const C = m.Route.options.component;
    return { default: (C as React.ComponentType) ?? (() => null) };
  });

export const ROUTE_CONTENT: Record<string, React.LazyExoticComponent<React.ComponentType>> = {
  "/classes": lazyFromRoute(() => import("../routes/classes")),
  "/maine-pan-production": lazyFromRoute(() => import("../routes/maine-pan-production")),
  "/atlantic-clarion": lazyFromRoute(() => import("../routes/atlantic-clarion")),
  "/calendar": lazyFromRoute(() => import("../routes/calendar")),
  "/contact": lazyFromRoute(() => import("../routes/contact")),
  "/history": lazyFromRoute(() => import("../routes/history")),
  "/sheet-music": lazyFromRoute(() => import("../routes/sheet-music")),
  "/nigel": lazyFromRoute(() => import("../routes/nigel")),
  "/recordings": lazyFromRoute(() => import("../routes/recordings")),
  "/monday-nights": lazyFromRoute(() => import("../routes/monday-nights")),
  "/pan-festival": lazyFromRoute(() => import("../routes/pan-festival")),
  "/last-night": lazyFromRoute(() => import("../routes/last-night")),
  "/learn-to-play": lazyFromRoute(() => import("../routes/learn-to-play")),
  "/planet-pan": lazyFromRoute(() => import("../routes/planet-pan")),
  "/pan-coalition": lazyFromRoute(() => import("../routes/pan-coalition")),
  "/logos": lazyFromRoute(() => import("../routes/logos")),
};

export const PAN_PATH_TO_KEY: Record<string, "education" | "productions" | "clarion"> = {
  "/classes": "education",
  "/maine-pan-production": "productions",
  "/atlantic-clarion": "clarion",
};
